export default __webpack_public_path__ + "static/media/Wind.ddf94d41.png";